import {wrap} from '@codeurs/front'
import React from 'react'
import {PageData} from '../../types'
import {style} from '../../util/style'
import {FormSectionType} from '../blocks/FormBlock'
import {EditionRegistrationForm} from '../evenementen/layout/EditionRegistration/EditionRegistrationForm'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Hero, HeroType} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {Theme} from '../Theme'

const styles = style('editionregistration', ['form'])

export type EditionRegistrationType = {
	hero: HeroType
	registration_type_individual: boolean
	registration_type_team: boolean
	registration_teamSections: Array<FormSectionType> | null
	reCaptchaKey: string
}

export const EditionRegistration: React.FC<
	PageData & EditionRegistrationType
> = wrap(Layout)(({...props}) => {
	const {
		parents,
		title,
		hero,
		registration_type_individual,
		registration_type_team,
		registration_teamSections,
		reCaptchaKey
	} = props

	return (
		<div className={styles()}>
			<Hero {...hero} title={(hero && hero.title) || title} />
			<Breadcrumbs parents={parents} title={title} />
			<EditionRegistrationForm
				reCaptchaKey={reCaptchaKey}
				registration_teamSections={registration_teamSections}
				registration_type_individual={registration_type_individual}
				registration_type_team={registration_type_team}
			/>
		</div>
	)
})
